var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Play/pause icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pause"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5C6 6.22386 6.22386 6 6.5 6H9C9.27614 6 9.5 6.22386 9.5 6.5V17.5C9.5 17.7761 9.27614 18 9 18H6.5C6.22386 18 6 17.7761 6 17.5V6.5Z",
    fill: "#181D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.5C14 6.22386 14.2239 6 14.5 6H17C17.2761 6 17.5 6.22386 17.5 6.5V17.5C17.5 17.7761 17.2761 18 17 18H14.5C14.2239 18 14 17.7761 14 17.5V6.5Z",
    fill: "#181D27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopBtn);
export default __webpack_public_path__ + "static/media/stopBtn.7c51eb8ad6324f690d701bd1c665c24c.svg";
export { ForwardRef as ReactComponent };